module.exports = __webpack_public_path__ + "50b7e634363fe6e3cd327a50dacf9686.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/goldencity2.jpg
// module id = 489
// module chunks = 0